  const promptsQuery = `{ allShoppingAssistantPrompts { text } }`;
  const chatHistory = [];
  const prompts = [];

  const showAssistant = () => {
    $('.assistant-container').show();
    $('body').css('overflow', 'hidden');

    if ($('.assistant-content-prompts').children().length === 0) {
      fetch('https://graphql.datocms.com/',
      {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer 1099c1c0a613651c486503c8c1b934`
          },
          body: JSON.stringify({ query: promptsQuery }),
      })
      .then(res => res.json())
      .then((res) => {
          prompts.push(...res.data.allShoppingAssistantPrompts);
          addPrompts(prompts);
      })
      .catch((error) => {
          console.log(error);
      });
    }

    if ($(window).width() > 767) {
      setTimeout(() => {
        if ($('header').hasClass('site-header--stuck')) {
          const stuckHeaderHeight = $('.site-header--stuck').innerHeight();
          $('.assistant-container').css('top', stuckHeaderHeight + 'px');
        } else {
          const headerHeight = $('#shopify-section-header').innerHeight();
          $('.assistant-container, .assistant-content-logo-horizontal').css('top', headerHeight + 28 + 'px');
        }
      }, 100);
    }

    $('#searchSuggestionsUL').html("");
    $('#searchSuggestions').hide();
    $('#searchPopParent').hide();

    $('.gray-overlay').hide();
    $('.close-search').hide();
    $('.search-mag-icon').show();
    $('.site-header__search-input').removeClass('is-active');
    $('.button-search').val("");
    $('.button-search').attr("placeholder","Search");

    
    if (window.innerWidth < 767) { 
        $('body').css('position', 'fixed');
    }

    $('#assistant-text-input').on("keypress", function(e) {
        if (e.keyCode == 13) {
        const query = e.currentTarget.value;
        
        if (query.length > 0) {
          fetchResponse(query);
        }
        
        $('#assistant-text-input').val('');
        return false;
        }
    });

    $('#assistant-title-input').on("keypress", function(e) {
        if (e.keyCode == 13) {
        const query = e.currentTarget.value;
        
        if (query.length > 0) {
          fetchResponse(query);
        }
        
        $('#assistant-title-input').val('');
        return false;
        }
    });

    $('#assistant-input-button').on("click", function(e) {
        if ($('#assistant-text-input')[0].value.length > 0) {
        const query = $('#assistant-text-input')[0].value;
        
        if (query.length > 0) {
            fetchResponse(query);
        }
        
        $('#assistant-text-input').val('');
        }
    });

    $('#assistant-title-input').on('input', function(e) {
        if (e.target.value.length > 0) {
        $('.title-submit-circle').css('fill', 'black');
        $('.title-submit-arrow').css('fill', 'white');
        } else {
        $('.title-submit-circle').css('fill', '#EEEDED');
        $('.title-submit-arrow').css('fill', '#BDBDBD');
        }
    });

    $('#assistant-title-input-button').on("click", function(e) {
        if ($('#assistant-title-input')[0].value.length > 0) {
        const query = $('#assistant-title-input')[0].value;
        
        if (query.length > 0) {
            fetchResponse(query);
        }
        
        $('#assistant-title-input').val('');
        }
    });

    $('#assistant-text-input').on('input', function(e) {
        if (e.target.value.length > 0) {
        $('.submit-circle').css('fill', 'black');
        $('.submit-arrow').css('fill', 'white');
        } else {
        $('.submit-circle').css('fill', '#EEEDED');
        $('.submit-arrow').css('fill', '#BDBDBD');
        }
    });

    $('#assistant-text-input, #assistant-title-input').on('click', function(e) {
        $('input[type="search"]').attr("disabled", "disabled");
        $(this).focus();
    });

    $('#assistant-text-input, #assistant-title-input').on('focusout', function(e) {
        $('input[type="search"]').attr("disabled", false);
    });
    
    //setTimeout(function() {  _satellite.track("AISearchClick"); }, 500)

    return false;
  }

  const addPrompts = (prompts) => {
    const promptsReversed = prompts.reverse();
    promptsReversed.forEach((prompt) => {
      $('.assistant-content-prompts').append(`<div class='prompt-text' onclick='selectPrompt(this)'>${prompt.text}</div>`);
    })
  };
  
  const fetchResponse = (query) => {
    var encodedQuery = $('<div />').text(query).html();
    const chatQuery = `<div class='chat-query'>${encodedQuery}</div>`;
    $('.assistant-content-container').append(chatQuery);

    $('.submit-circle').css('fill', '#EEEDED');
    $('.submit-arrow').css('fill', '#BDBDBD');
    $('.title-submit-circle').css('fill', '#EEEDED');
    $('.title-submit-arrow').css('fill', '#BDBDBD');
    $('.prompt-text').hide();
    $('.assistant-content-container-wrapper').hide();
    if ($(window).width() <= 767) {
      $('.assistant-content-logo-horizontal-mobile').show();
    } else {
      $('.assistant-content-logo-horizontal').show();
    }
    disableInputs();
    showLoader();

    $('.assistant-container').animate({
      scrollTop: $('.assistant-container').prop('scrollHeight')
    }, 1000);
    
    fetch('https://spo-partner-api.azure-api.net/ai-chat/v3/',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Ocp-Apim-Subscription-Key': '1bba7d6077014bedabd84bf5eb6fd149'
      },
      body: JSON.stringify({"question": encodedQuery,"chat_history": chatHistory }),
    })
    .then(res => res.json())
    .then((data) => {
      appendResponse(encodedQuery, data)
    })
    .catch((error) => {
      console.log(error);
    });
  }

  const selectPrompt = (prompt) => {
    const query = $(prompt).text();
    fetchResponse(query);
  }

  const showLoader = () => {
    $('.assistant-loading').show();
    $('.assistant-loading').slick({
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      slide: '.loading-container'
    });        
    $('.assistant-loading').slick('slickGoTo', 1, true);
	  $('.assistant-loading').slick('slickGoTo', 0, true);
  }

  const hideLoader = () => {
    $('.assistant-loading').hide();
    $('.assistant-loading').slick('unslick');
  }

  const enableInputs = () => {
    $('#assistant-text-input').on("keypress", function(e) {
      if (e.keyCode == 13) {
        const query = e.currentTarget.value;
        
        if (query.length > 0) {
          fetchResponse(query);
        }
        
        $('#assistant-text-input').val('');
        return false;
      }
    });

    $('#assistant-title-input').on("keypress", function(e) {
      if (e.keyCode == 13) {
        const query = e.currentTarget.value;
        
        if (query.length > 0) {
          fetchResponse(query);
        }
        
        $('#assistant-title-input').val('');
        return false;
        }
    });

    $('#assistant-input-button').on("click", function(e) {
      if ($('#assistant-text-input')[0].value.length > 0) {
        const query = $('#assistant-text-input')[0].value;
        
        if (query.length > 0) {
          fetchResponse(query);
        }
        
        $('#assistant-text-input').val('');
      }
    });
  }

  const disableInputs = () => {
    $('#assistant-text-input').off("keypress");
    $('#assistant-input-button').off("click");
  }

  const hideAssistant = () => {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const page = params.get('page');
    const pbQuery = params.get('pb');
    const query = params.get('q');

    if (((params.size > 2 && !pbQuery) || (params.size > 3 && pbQuery)) || page > 1 || !query) {
      $('#srp-shopping-assistant').hide();
    } else {
      $('#srp-shopping-assistant').show();
    }

    $('.assistant-container').hide();
    $('body').css('position', '');
    $('body').css('overflow', 'auto');
  }

  const openBetaModal = () => {
    $('.assistant-modal-overlay').show();
    $('#beta-chat-modal').show();
  }

  const resetChat = () => {
    if (chatHistory.length > 0) {
      $('.assistant-modal-overlay').show();
      $('#reset-chat-modal').show();
    }
  }

  const closeResetModal = () => {
    $('.assistant-modal-overlay').hide();
    $('#reset-chat-modal').hide();
  }

  const closeBetaModal = () => {
    $('.assistant-modal-overlay').hide();
    $('#beta-chat-modal').hide();
  }

  const confirmReset = () => {
    $('.assistant-content-container').children().not('.assistant-content-container-wrapper, .prompt-text, .assistant-content-prompts, .assistant-content-logo-horizontal, .assistant-content-logo-horizontal-mobile').each(function() {
      $(this).remove();
    });

    if (!prompts.length) {
      fetch('https://graphql.datocms.com/',
      {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer 1099c1c0a613651c486503c8c1b934`
          },
          body: JSON.stringify({ query: promptsQuery }),
      })
      .then(res => res.json())
      .then((res) => {
          prompts.push(...res.data.allShoppingAssistantPrompts);
          addPrompts(prompts);
      })
      .catch((error) => {
          console.log(error);
      });
    }
    
    $('.assistant-content-container-wrapper').show();
    $('.assistant-content-title').show();
    $('.assistant-content-prompts').show();
    if ($(window).width() <= 767) {
      $('.assistant-content-logo-horizontal-mobile').hide();
    } else {
      $('.assistant-content-logo-horizontal').hide();
    }
    $('.assistant-input').hide();
    $('.prompt-text').show();
    $('.reset-arrow').css('fill', '#BDBDBD');
    $('#assistant-text-input').attr('placeholder', 'Ask me anything');
    chatHistory.length = 0;

    $('.assistant-modal-overlay').hide();
    $('#reset-chat-modal').hide();
  }

  const appendResponse = (query, data) => {
    if (!data.chat_response) {
      const errorResponse = `<div class='follow-up-response'>
        <p class='full-response'>Uh-oh! Looks like our assistant came up empty-handed. Adjust your search and let's try this again.</p>
      </div>`;

      $('.assistant-content-container').append(errorResponse);
      hideLoader();
      enableInputs();
      $('.assistant-input').css('display', 'flex');
      return;
    }
    
    hideLoader();
    enableInputs();
    $('#assistant-text-input').attr('placeholder', 'Ask a follow up question');

    chatHistory.push({
      'inputs': {
        'question': query
      },
      'outputs': {
        'answer': data.chat_response
      }
    });
 
    $('.assistant-container').animate({
      scrollTop: $('.assistant-container').prop('scrollHeight')
    }, 1000);

    $('.reset-arrow').css('fill', 'black');

    let hasShortResponse = false;
    let shortResponse;
    const fullResponse = data.chat_response;
      
    if (data.chat_response.length > 450 && $(window).width() > 767) {
      hasShortResponse = true;
      shortResponse = fullResponse.substring(0, 450) + ' ...';
    } else if (data.chat_response.length > 120 && $(window).width() < 768){
      hasShortResponse = true;
      shortResponse = fullResponse.substring(0, 140) + ' ...';
    }

    let hasShortFollowResponse = false;
    let shortFollowResponse;
    const fullFollowResponse = data.follow_up ? data.follow_up : '';
    //console.log(data.chat_response);
    if (fullFollowResponse.indexOf("<") > -1 || fullFollowResponse.indexOf("def ") > -1 || data.chat_response.indexOf("<") > -1 || data.chat_response.indexOf("def ") > -1)
    {
      let errorResponse = `<div class='follow-up-response'>
        <p class='full-response'>Uh-oh! Looks like something went wrong. Please try again.</p>
      </div>`;

      $('.assistant-content-container').append(errorResponse);
      hideLoader();
      enableInputs();
      return;
    }
      
    if (data.chat_response.length > 450 && $(window).width() > 767) {
      hasShortFollowResponse = true;
      shortFollowResponse = fullFollowResponse.substring(0, 450) + ' ...';
    } else if (data.chat_response.length > 120 && $(window).width() < 768){
      hasShortFollowResponse = true;
      shortFollowResponse = fullFollowResponse.substring(0, 140) + ' ...';
    }
    
    const chatResponse = hasShortResponse ? `
    <div class='chat-response'>
      <p class='short-response'>${shortResponse}</p>
      <p class='full-response' style='display: none;'>${fullResponse}</p>
      <a href='javascript:void(0);' onclick='readMoreChat(this)' class='read-more-chat'>read more</a>
    </div>` : 
    `<div class='chat-response'>
      <p class='full-response'>${fullResponse}</p>
    </div>`;
    let productCarousel = `<div class='assistant-product-carousel'>`;
    const followUpResponse = hasShortFollowResponse ? 
      `
      <div class='follow-up-response'>
        <p class='short-follow-response'>${shortFollowResponse}</p>
        <p class='full-follow-response' style='display: none;'>${fullFollowResponse}</p>
        <a href='javascript:void(0);' onclick='readMoreFollow(this)' class='read-more-follow'>read more</a>
      </div>` :
    `<div class='follow-up-response'>
      <p class='full-follow-response'>${fullFollowResponse}</p>
    </div>`;

    for (const product of data.products) {
      if ($(window).width() < 768) {
        imgSize = '_390x';
      } else {
        imgSize = '_275x';
      }

      if (product.Images.length > 0) {
        imgUrl = product.Images[0].replace(/(\.[^.]*)$/,imgSize+"$1");
      }

      let discount = '';
      let promoStr = '';
      if (product.activePromo) {
        if (product.activePromo.discountType === 'percentage') {
          discount = `${product.activePromo.discountValue}%`;
        } else if (product.activePromo){
          discount = `$${product.activePromo.discountValue}`;
        }
        promoStr = `Extra ${discount} Off with Code: ${product.activePromo.code}`;
      }
      
      productCarousel += `
      <a class="assistant-product" href=${window.location.origin}/products/${product.Handle}?cid=aiclick:asst target="_blank">
          <div class="assistant-product-container">
            <div class="assistant-product-overlay"></div>
            <div class="lazyloaded assistant-product-img" data-background-image-url="${imgUrl}" style="background-image: url(${imgUrl})"></div>
          </div>
          <div class="assistant-product-brand">${product.Brand}</div>
          ${discount ? `<div class="assistant-product-promo">${promoStr}</div>` : ''}
          <div class="assistant-product-sale">$${product.Price.toFixed(2)}</div><div class="assistant-product-price">$${product.CompareAtPrice}</div>
      </a>
      `;
    }

    productCarousel += '</div>';

    $('.assistant-content-container').append(chatResponse);
    if (productCarousel.length > 0) {
      $('.assistant-content-container').append(productCarousel);
    }
    $('.assistant-content-container').append(followUpResponse);
    $('.assistant-input').css('display', 'flex');

    setTimeout(function() {
      $('.assistant-product-carousel').fadeIn();

      $('.assistant-product-carousel').each(function() {
        $(this).not('.slick-initialized').slick({
          infinite: false,
          slidesToShow: 7,
          slidesToScroll: 7,
          prevArrow: `<svg class="assistant-carousel-button buttons-prev slick-arrow" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style="">
              <circle cx="24" cy="24" r="24" fill="white"></circle>
              <g clip-path="url(#clip0_4854_37336)">
                  <path d="M32.0123 24.5123C32.01 24.777 31.9049 25.0305 31.7193 25.2193L21.7193 35.2193C21.5307 35.4014 21.2781 35.5022 21.0159 35.5C20.7537 35.4977 20.5029 35.3925 20.3175 35.2071C20.1321 35.0217 20.0269 34.7709 20.0246 34.5087C20.0223 34.2465 20.1231 33.9939 20.3053 33.8053L29.5983 24.5123L20.3053 15.2193C20.2098 15.127 20.1336 15.0167 20.0812 14.8947C20.0288 14.7727 20.0012 14.6415 20 14.5087C19.9989 14.3759 20.0242 14.2442 20.0745 14.1213C20.1247 13.9984 20.199 13.8868 20.2929 13.7929C20.3868 13.699 20.4984 13.6247 20.6213 13.5745C20.7442 13.5242 20.8759 13.4989 21.0087 13.5C21.1415 13.5012 21.2727 13.5288 21.3947 13.5812C21.5167 13.6336 21.627 13.7098 21.7193 13.8053L31.7193 23.8053C31.9049 23.9941 32.01 24.2475 32.0123 24.5123Z" fill="black"></path>
              </g>
              <defs>
                  <clipPath id="clip0_4854_37336">
                      <rect width="24" height="24" fill="white" transform="translate(8 12)"></rect>
                  </clipPath>
              </defs>
          </svg>`,
          nextArrow: `<svg class="assistant-carousel-button buttons-next slick-arrow" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style="">
              <circle cx="24" cy="24" r="24" fill="white"></circle>
              <g clip-path="url(#clip0_4854_37336)">
                  <path d="M32.0123 24.5123C32.01 24.777 31.9049 25.0305 31.7193 25.2193L21.7193 35.2193C21.5307 35.4014 21.2781 35.5022 21.0159 35.5C20.7537 35.4977 20.5029 35.3925 20.3175 35.2071C20.1321 35.0217 20.0269 34.7709 20.0246 34.5087C20.0223 34.2465 20.1231 33.9939 20.3053 33.8053L29.5983 24.5123L20.3053 15.2193C20.2098 15.127 20.1336 15.0167 20.0812 14.8947C20.0288 14.7727 20.0012 14.6415 20 14.5087C19.9989 14.3759 20.0242 14.2442 20.0745 14.1213C20.1247 13.9984 20.199 13.8868 20.2929 13.7929C20.3868 13.699 20.4984 13.6247 20.6213 13.5745C20.7442 13.5242 20.8759 13.4989 21.0087 13.5C21.1415 13.5012 21.2727 13.5288 21.3947 13.5812C21.5167 13.6336 21.627 13.7098 21.7193 13.8053L31.7193 23.8053C31.9049 23.9941 32.01 24.2475 32.0123 24.5123Z" fill="black"></path>
              </g>
              <defs>
                  <clipPath id="clip0_4854_37336">
                      <rect width="24" height="24" fill="white" transform="translate(8 12)"></rect>
                  </clipPath>
              </defs>
          </svg>`,
          responsive: [
            {
              breakpoint: 769,
              settings: 'unslick'
            }
          ]
        });
      });
    }, 200);
  }

  const readMoreChat = (e) => {
    if ($(e).siblings('.full-response').is(":visible")) {
      $(e).text('read more');
      $(e).insertAfter($(e).siblings('.short-response'));
      $(e).siblings('.full-response').hide();
      $(e).siblings('.short-response').css('display', 'inline');
    } else {
      $(e).text('read less');
      $(e).insertAfter($(e).siblings('.full-response'));
      $(e).siblings('.short-response').hide();
      $(e).siblings('.full-response').css('display', 'inline');
    }
  }

  const readMoreFollow = (e) => {
    if ($(e).siblings('.full-follow-response').is(":visible")) {
      $(e).text('read more');
      $(e).insertAfter($(e).siblings('.short-follow-response'));
      $(e).siblings('.full-follow-response').hide();
      $(e).siblings('.short-follow-response').css('display', 'inline');
    } else {
      $(e).text('read less');
      $(e).insertAfter($(e).siblings('.full-follow-response'));
      $(e).siblings('.short-follow-response').hide();
      $(e).siblings('.full-follow-response').css('display', 'inline');
    }
  }

  const showAssistantFromSearch = (query, data) => {
    $('#srp-shopping-assistant').hide();
    $('.assistant-container').show();
    $('body').css('overflow', 'hidden');
    $('.assistant-content-container').children().not('.assistant-content-container-wrapper, .assistant-content-title, .assistant-content-logo-horizontal, .assistant-content-logo-horizontal-mobile, .assistant-content-prompts').each(function() {
      $(this).remove();
    });
    showLoader();

    appendResponse(query, data)

    if ($(window).width() > 767) {
      $(window).scrollTop(0);
      setTimeout(() => {
        const headerHeight = $('#shopify-section-header').innerHeight();
        $('.assistant-container, .assistant-content-logo-horizontal')
          .css('top', headerHeight + 28 + 'px');
      }, 0);
    }

    $('#searchSuggestionsUL').html("");
    $('#searchSuggestions').hide();
    $('#searchPopParent').hide();
    $('.assistant-content-title').hide();
    $('.assistant-content-container-wrapper').hide();
    $('.assistant-content-prompts').hide();
    $('.gray-overlay').hide();
    $('.close-search').hide();
    $('.search-mag-icon').show();
    $('.site-header__search-input').removeClass('is-active');
    $('.button-search').val("");
    $('.button-search').attr("placeholder","Search");
    if ($(window).width() <= 767) {
      $('.assistant-content-logo-horizontal-mobile').show();
    } else {
      $('.assistant-content-logo-horizontal').show();
    }
    
    if (window.innerWidth < 767) { 
      $('body').css('position', 'fixed');
    }

    $('#assistant-text-input').on("keypress", function(e) {
      if (e.keyCode == 13) {
        const query = e.currentTarget.value;
        
        if (query.length > 0) {
          fetchResponse(query);
        }
        
        $('#assistant-text-input').val('');
        return false;
      }
    });

    $('#assistant-title-input').on("keypress", function(e) {
      if (e.keyCode == 13) {
        const query = e.currentTarget.value;
        
        if (query.length > 0) {
          fetchResponse(query);
        }
        
        $('#assistant-title-input').val('');
        return false;
      }
    });

    $('#assistant-input-button').on("click", function(e) {
      if ($('#assistant-text-input')[0].value.length > 0) {
        const query = $('#assistant-text-input')[0].value;
        
        if (query.length > 0) {
          fetchResponse(query);
        }
      
        $('#assistant-text-input').val('');
      }
    });

    $('#assistant-title-input').on('input', function(e) {
        if (e.target.value.length > 0) {
        $('.title-submit-circle').css('fill', 'black');
        $('.title-submit-arrow').css('fill', 'white');
        } else {
        $('.title-submit-circle').css('fill', '#EEEDED');
        $('.title-submit-arrow').css('fill', '#BDBDBD');
        }
    });

    $('#assistant-title-input-button').on("click", function(e) {
        if ($('#assistant-title-input')[0].value.length > 0) {
        const query = $('#assistant-title-input')[0].value;
        
        if (query.length > 0) {
            fetchResponse(query);
        }
        
        $('#assistant-title-input').val('');
        }
    });

    $('#assistant-text-input').on('input', function(e) {
      if (e.target.value.length > 0) {
        $('.submit-circle').css('fill', 'black');
        $('.submit-arrow').css('fill', 'white');
      } else {
        $('.submit-circle').css('fill', '#EEEDED');
        $('.submit-arrow').css('fill', '#BDBDBD');
      }
    });

    $('#assistant-text-input, #assistant-title-input').on('click', function(e) {
      $('input[type="search"]').attr("disabled", "disabled");
      $(this).focus();
    });

    $('#assistant-text-input, #assistant-title-input').on('focusout', function(e) {
      $('input[type="search"]').attr("disabled", false);
    });
    
    //setTimeout(function() {  _satellite.track("AISearchClick"); }, 500)

    return false;
  }
  